import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { identity, not } from "ramda"
import React, { FC } from "react"
import { useThemeContext } from "../theme/ThemeContext"

export interface SelectorProps {
    className?: string
    disabled?: boolean
    fullwidth?: boolean
    hidden?: boolean
    helperText?: string
    margin?: "none" | "dense" | "normal"
    label?: string
    onChange?: (event: any) => void
    required?: boolean
    textAdapter?: ((value: any) => string)
    style?: React.CSSProperties | undefined
    value?: any
    variant?: "filled" | "standard" | "outlined"
    menuItems?: any[]
    multiple?: boolean
    error?: boolean
    size?: 'small' | 'medium'
}

const Selector: FC<SelectorProps> = ({ className = "", disabled = false, fullwidth = true, hidden = false, helperText = "", margin = "normal", label = "",
    onChange, required = false, error = false, textAdapter = identity, value = [], style = undefined, variant = "outlined", menuItems = [], multiple = false, size = 'medium' }) => {  
    const { theme } = useThemeContext()

    return <div style={style} className={className} id={className}>
       {not(hidden) && <FormControl fullWidth={fullwidth} margin={margin} variant={variant}>
            <InputLabel id={'select'} style={{padding: "0px 8px", backgroundColor: theme.palette.info.main }} required={required}>{label}</InputLabel>
            <Select disabled={disabled} multiple={multiple} id={'select'} required={required}
                    inputProps={required ? {id:'selectInput', required: true } : {id:'selectInput', required: false}}
                    size={size}
                    error={error}
                    
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: theme.palette.action.disabled},
                      "& .MuiFormLabel-root.Mui-disabled": {
                          color: theme.palette.action.disabled,
                        }}}
                    value={ value === undefined || value === null ? '' : typeof value === 'string' ? value.split(',') : value } onChange={onChange}>
                {menuItems.map(((item) => <MenuItem value={item} id={textAdapter(item)} key={textAdapter(item)} style={{ fontWeight: (multiple && value && value.includes(item)) ? 800 : 400 }}>{textAdapter(item)}</MenuItem>))}
            </Select>
        </FormControl>}
    </div>
        //{not(isEmpty(helperText)) && <FormHelperText>{helperText}</FormHelperText>}
        //</FormControl>}
    }
export default Selector